import { useActiveScope } from '@features/account-view/active';
import { DivisionFilter } from '@features/orders/components/header/DivisionFilter';
import { countryFlag } from '../../lib/markets';

export type CatalogDivisionFilterProps = {
  /** After the choice changed, e.g. to go back to the first page. */
  onChange?: () => void;
  className?: string;
  /** M2 (Ely 11-01): division id -> the one country it sells in; that flag goes before its name. */
  divisionCountries?: ReadonlyMap<string, string>;
};

/* EN-4396: the account level's filter by division; the division level has none. */
export function CatalogDivisionFilter({
  onChange,
  className,
  divisionCountries,
}: CatalogDivisionFilterProps) {
  const { level, divisions, divisionFilter, setDivisionFilter } =
    useActiveScope();

  if (level !== 'account') return null;

  return (
    <DivisionFilter
      divisions={divisions.map(division => {
        const country = divisionCountries?.get(division.id);
        return country
          ? { ...division, name: `${countryFlag(country)} ${division.name}` }
          : division;
      })}
      values={divisionFilter}
      onChange={ids => {
        setDivisionFilter(ids);
        onChange?.();
      }}
      className={className}
    />
  );
}
